import {Inject, Injectable, Injector, Renderer2, RendererFactory2} from '@angular/core';
import {GlobalService} from 'app/global/global.service';
import {delay, of, Subscription, take} from 'rxjs';
import uuid from 'short-unique-id';
import {PopOver} from '../popover/popover';
import { DomHelperService } from 'app/global/dom-helper.service';
import { Router } from '@angular/router';
import {Block} from 'app/interfaces/blocks';
import { ProductlibraryService } from 'app/main/pages/settings/productlibrary/productlibrary.service';
import { PricingDTO } from 'app/interfaces/productTable.dto';
import { translate } from '@jsverse/transloco';
import { RefreshFileService } from 'app/main/signing-pages/helpers/refresh-file.service';
import { RoleDetail } from 'app/main/signing-pages/signing-page/signing-page.dto';
import { SessionImageService } from 'app/global/session-image.service';

export const billingFrequency = function () {
    return [
               { "label": translate("Billing frequency one time (Product library) - One time"), "value": "one_time" },
               { "label": translate("Billing frequency Monthly (Product library) - Monthly"), "value": "monthly" },
               { "label": translate("Billing frequency Quarterly (Product library) - Quarterly"), "value": "quarterly" },
               { "label": translate("Billing frequency Semi annually (Product library) - Semi annually"), "value": "semi_annually" },
               { "label": translate("Billing frequency Annually (Product library) - Annually"), "value": "annually" },
               { "label": translate("Billing frequency Every two years (Product library) - Every two years"), "value": "every_two_years" },
               { "label": translate("Billing frequency Every three years (Product library) - Every three years"), "value": "every_three_years" },
               { "label": translate("Billing frequency Every five years (Product library) - Every five years"), "value": "every_five_years" }
    ]
};

export const billingFrequencyLabels = function(){
   const values = billingFrequency();
   const labels = {};
   for(let i = 0; i < values.length; i ++){
      labels[values[i].value] = values[i].label;
   }
   return labels;
}

@Injectable({
   providedIn: 'root',
})

export class productTable {
   public instance_name: string = '';
   public uuid = new uuid({ length: 6, dictionary: 'number' });
   public keydownCount: number = 0;
   public selectMenuIsOpen: boolean = false;
   public timeOutSubscription: Subscription;
   public billingFrequencyLabels = billingFrequencyLabels();
   public isSigningArea: boolean = false;
   public roleData: RoleDetail;
   public isEform: boolean;
   private renderer: Renderer2;
   
   constructor(
      @Inject(Injector) private readonly injector: Injector,
      private _router: Router,
      private productLibraryService: ProductlibraryService,
      private rendererFactory: RendererFactory2,
      private refreshFileService: RefreshFileService,
      private sessionImageService: SessionImageService
   ) { 
      this.renderer = this.rendererFactory.createRenderer(null, null);
   }

   /**
    * Product table box
    * @param params 
    */
   productTableBox(params: { uuid?:string, type?:string, currency?:string } = {}, blockData) {
      const defaultProductTable = this.defaultTable(blockData);
      const productTableElement = document.createElement('div')
      productTableElement.className = 'content-box content-box-block product-table-block marginminus70';
      productTableElement.innerHTML = `<div class="sort-helper">
        </div><div class="content-box-row"><div class="rowItem">${this.popOverFunc.listingPopover({ classType: 'product-table', uuid: params.uuid, contentType: 'settings' })}<div class="content-box-inner" editor-uuid="${params.uuid}" type="product-table"><div class="editor${params.uuid} cke-editor-placeholder cke-editor-box product-table" editor-uuid="${params.uuid}" ><div class="product-table-parent-container producttable-main-container">${defaultProductTable}</div></div></div></div></div>`;
      if (document.querySelectorAll('.dropIndicator-bottom').length === 0 &&
         document.querySelector('.template-page')?.classList.contains('addContentBox')) {
         document.querySelector('.template-page').appendChild(productTableElement);
      } else if (document.querySelector('.content-box-inner.active-border') &&
         params.type === 'slashcommand') {
         const parentBox = document.querySelector('.content-box-inner.active-border')?.closest('.content-box');
         parentBox?.parentNode?.insertBefore(productTableElement, parentBox.nextSibling);
      } else {
         const parentBox = document.querySelector('.dropIndicator-bottom')?.closest('.content-box');
         parentBox?.parentNode?.insertBefore(productTableElement, parentBox.nextSibling);
      }

      this.GlobalServiceFunc.contentBoxSort();
      this.timeOutSubscription = of(null).
      pipe(
         delay(200),
         take(1)
      ).subscribe(() => {
         const editorEl = document.querySelector('.editor' + params.uuid);
         if (editorEl) {
            const contentBox = editorEl.closest('.content-box-inner');
            if (contentBox) {
               contentBox.classList.add('active-border');
            }
         }
      });
   }

   getProductColumnColspan(blockData, imgBox){
      let colspan = 1;
      if((!blockData?.columns?.image || !imgBox)){
         colspan = 2;
      }
      return colspan;
   }

   /**
    * Add product row
    * @param params 
    * @returns 
    */
   addRow(blockData, product, section, sectionId){
      let imgBox = '';
      if(product?.images && product.images.length > 0){
         let imgUrl = ''; 
         const imgUuid = product.images[0]?.uuid;
         if(!this.isSigningArea){
            const imgPath = product.images[0]?.image_url;
            if(imgPath){
               if(imgPath.includes('productlibrary')){
                  imgUrl = this.productLibraryService.getProductImage(imgPath ,product?.id);
               } else {
                  imgUrl = this.sessionImageService.getTemplateImages(imgPath, sectionId, section);              
               }
            }
         }
         imgBox = `<td class="pt-column-image ${(!blockData?.columns?.image ? 'hidden' : '')}">
                     <span>
                        <img
                        class="product-img-box"
                        product-id="${product?.id}"
                        img-uuid="${imgUuid}"
                        src="${imgUrl}"
                        />
                     </span>
                  </td>`;
      }
      const descColspan = this.getProductColumnColspan(blockData, imgBox);
      let customColumns = '';
      if(blockData?.columns?.custom_fields){
         Object.entries(blockData?.columns?.custom_fields).forEach(([fieldId, fieldName]) => {
            const customField = (product?.custom_fields || []).find(
               f => Number(f.meta_data_id) === Number(fieldId)
            );
            const customFieldValue = customField?.value ?? '';
            const customFieldContent = customFieldValue.trim()
               ? `<b>&nbsp; ${fieldName}:</b> ${customFieldValue}`
               : '';
            customColumns += `<span class="pt-custom-column-box" column-id="${fieldId}">
               ${customFieldContent}
               </span>`;
         });
      }

      const productfieldstyle = `style-product-field --product-field-size --product-field-color`
      const pricestyle = `style-price --price-size --price-color`;

      let totalPriceBox = '';
      if(product?.qty > 1){
         totalPriceBox = `<div class="price-bottom pt-column-price ${(!blockData?.columns?.price ? 'hidden' : '')}">
            <div class="price-bottom-label ${pricestyle}">
               <small>${translate('Total data design label (Summary settings) - Total')}</small>
            </div>
            <div class="price-bottom-amount ${pricestyle}">
               ${product?.total ?? '0.00'} ${product?.currency}
            </div>
            <div class="price-bottom-frequency ${productfieldstyle}">
               / <span>${product?.billing_frequency_label ?? this.billingFrequencyLabels['one_time']}</span>
            </div>
         </div>`;
      }

      const row = `<tr class="item_row product-row-border pt-item-row" table-uuid="${blockData.uuid}">
      ${imgBox}
                  <td class="item_name pt-25 pt-item-data" colspan="${descColspan}">
                     <div class="titleDescriptionTable ps-0">
                        <div class="title-desc">
                        <div class="pt-column-title-description">
                           <div class="tableTitleTd style-product-name --product-name-size --product-name-color">
                              <b>${product?.product_name ?? ''}</b>
                           </div>

                           <div class="pt-column-description ${(!blockData?.columns?.description ? 'hidden' : '')}">
                              <div class="tableDescriptionTd ${productfieldstyle}">
                              ${product?.description ?? ''}
                              </div>
                           </div>
                        </div>
                        <div class="price-top pt-column-price ${(!blockData?.columns?.price ? 'hidden' : '')}">
                           <div class="price-amount ${pricestyle}">
                              ${product?.price ?? '0.00'} ${product?.currency ?? 'SEK'}
                           </div>
                           <div class="price-frequency ${productfieldstyle}">
                              / <span>${product?.billing_frequency_label ?? this.billingFrequencyLabels['one_time']}</span>
                           </div>
                        </div>
                        </div>
                        <div class="pt-column-footer">
                        <div class="py-0 w-100 pt-custom-columns ${productfieldstyle}" product-id="${product?.id}">
                           <span class="pt-column-terms ${(!blockData?.columns?.terms ? 'hidden' : '')}">
                              <b>${blockData?.labels?.terms ?? translate('Product form Terms field (Product library) - Terms')}:</b>
                              ${product?.terms ?? '1'}
                           </span>
                           <span class="pt-column-quantity ${(!blockData?.columns?.quantity ? 'hidden' : '')}">
                              <b>${blockData?.labels?.quantity ?? translate('Quantity label (Product table settings) - Quantity')}:</b> ${product?.qty ?? '1'}
                           </span>    
                           ${customColumns}      
                        </div>
                        ${totalPriceBox}
                        </div>
                     </div>
                  </td>
                  </tr>`;
      return row;
   }

   /**
    * Default table
    * @param params 
    * @returns HTML
    */
   defaultTable(blockData) {
      return `<table class="product-table-content calculationTemplate openProductLibraryModal calculationTemplateTable calculation_table general_calculation_table sar-table initResize0 product-table-borders-v product-table-borders-h --font-family" style="--font-family: ${blockData?.design?.font_family}; --title-size: ${blockData?.design?.title?.font_size ?? 16}px; --title-color: ${blockData?.design?.title?.font_color ?? '#6e6b7b'}; --product-name-size: ${blockData?.design?.product_name?.font_size ?? 14}px; --product-name-color: ${blockData?.design?.product_name?.font_color ?? '#374151'}; --product-field-size: ${blockData?.design?.product_field?.font_size ?? 12}px; --product-field-color: ${blockData?.design?.product_field?.font_color ?? '#6b7280'};  --price-size: ${blockData?.design?.price?.font_size ?? 12}px; --price-color: ${blockData?.design?.price?.font_color ?? '#374151'}" table-uuid="${blockData.uuid}" id="JColResizer0">
                  <thead>
                     <tr class="item_row pt-column-title pt-hidden-title ${(!blockData?.columns?.title ? 'hidden' : '')}">
                        <td colspan="2">
                           <h4 class="mb-50 mt-25 fw-bold text-black"><b class="product-table-title style-title --title-size --title-color">${blockData?.name}</b></h4>
                        </td>
                     </tr>
                  </thead>
                  <tbody>
                  </tbody>
               </table>
               <table class="product-table-default-box" button-table-uuid="${blockData.uuid}">
                  <tbody>
                     <tr>
                        <td class="add-from-products-btn">        
                           <div class="addfromlib productTableFooterBtn openProductLibraryModal" id="addFromCatalogPopupBtn" table-uuid="${blockData.uuid}"><span>${translate("New product table box label (Product table settings) - Select Products from Library")}</span></div>
                        </td>
                     </tr>
                  </tbody>
               </table>`;
   }

   /**
    * Initialize product table all events
    * @param tableUuid 
    */
   refreshProductTableEvents(){
      if(!this.isSigningArea){
         this.domHelperService.initializeEventListener('.openProductLibraryModal', 'click', 'openProductLibraryModal');
      }
   }

   /**
    * Initialize product table on signing area
    */
   initializeOnSigningArea(tableUuid, roleData, isEform){
      this.isSigningArea = true;
      this.roleData = roleData;
      this.isEform = isEform;
      const tableContainer = document.querySelector(
            `.product-table[editor-uuid="${tableUuid}"]`
         );  
      if(tableContainer){
         this.renderer.addClass(tableContainer, 'allowed-edit');
         this.domHelperService.initializeEventListener(`.openProductLibraryModal[table-uuid="${tableUuid}"]`, 'click', 'openProductLibraryModal');
      }       
   }

   updateProductTableData(blockData){
      if(this.isSigningArea){
         this.refreshFileService.refreshProductTableImages(blockData, this.roleData?.id ?? 0, this.roleData?.roleable_id ?? 0, this.isEform);
      }
   }

   /**
    * Product table summary box
    * @param params 
    */
   productTableSummaryBox(blockData) {
      const defaultProductTable = `<div class="summary-card --font-family" summary-uuid="${blockData.uuid}" style="--font-family: ${blockData?.design?.font_family}; --title-size: ${blockData?.design?.title?.font_size ?? 16}px; --title-color: ${blockData?.design?.title?.font_color ?? '#6e6b7b'}; --summary-size: ${blockData?.design?.summary?.font_size ?? 12}px; --summary-color: ${blockData?.design?.summary?.font_color ?? '#9aa4b2'}; --total-size: ${blockData?.design?.total?.font_size ?? 14}px; --total-color: ${blockData?.design?.total?.font_color ?? '#6e6b7b'};">
                     <div class="summary-inner">
                        <h3 class="summary-title mb-75 border-bottom pb-1 style-title ${blockData?.columns?.title === false ? 'hidden' : ''}" summary-column="title">Summary</h3>
                        <table class="product-table-summary style-summary --summary-color --summary-size">
                           <tbody class="summary-data">
                              <tr class="summary-row ${blockData?.columns?.quantity === false ? 'hidden' : ''}" summary-column="quantity">
                                 <td class="summary-label" label="quantity">${blockData?.labels?.quantity ?? translate('Quantity label (Product table settings) - Quantity')}</td>
                                 <td class="summary-value" column="summary-column-quantity"></td>
                              </tr>
                              <tr class="summary-row ${blockData?.columns?.pricepermonth === false ? 'hidden' : ''}" summary-column="pricepermonth">
                                 <td class="summary-label" label="pricepermonth">${blockData?.labels?.pricepermonth ?? translate('Price per month label (Summary settings) - Price per month')}</td>
                                 <td class="summary-value" column="netPerMonth"></td>
                              </tr>
                              <tr class="summary-row ${blockData?.columns?.onetimecost === false ? 'hidden' : ''}" summary-column="onetimecost">
                                 <td class="summary-label" label="onetimecost">${blockData?.labels?.onetimecost ?? translate('One time cost label (Summary settings) - One time cost')}</td>
                                 <td class="summary-value" column="netOneTime"></td>
                              </tr>
                              <tr class="summary-row summary-discount hidden" summary-column="discount">
                                 <td class="summary-label" label="discount">${blockData?.labels?.discount ?? translate("Product table settings discount text (Template/Document - section) - Discount")}</td>
                                 <td class="summary-value"></td>
                              </tr>
                              <tr class="summary-row summary-tax hidden">
                                 <td class="summary-label" label="tax">${blockData?.labels?.tax ?? translate("Product table settings tax text (Template/Document - section) - Tax")}</td>
                                 <td class="summary-value"></td>
                              </tr>
                              <tr class="summary-total style-total --total-size --total-color">
                                 <td class="summary-total-label" label="total">${blockData?.labels?.total ?? translate("Total data design label (Summary settings) - Total")}:</td>
                                 <td class="summary-total-value"></td>
                              </tr>
                           </tbody>
                        </table>
                        <hr class="summary-divider summary-secret-data" />
                        <div class="summary-metrics summary-secret-data">
                           <span>${translate("Only shows for you label (Summary settings) - Only shows for you")}: </span>
                           <span>MRR: <span column="MRR"></span></span>
                           <span>ARR: <span column="ARR"></span></span>
                           <span>ACV: <span column="ACV"></span></span>
                           <span>TCV: <span column="TCV"></span></span>
                        </div>
                     </div>
                  </div>`;
      const productTableElement = document.createElement('div')
      productTableElement.className = 'content-box content-box-block product-table-summary-block marginminus70';
      productTableElement.innerHTML = `<div class="sort-helper">
        </div><div class="content-box-row"><div class="rowItem">${this.popOverFunc.listingPopover({ classType: 'product-table-summary', uuid: blockData.uuid, contentType: 'settings' })}<div class="content-box-inner" editor-uuid="${blockData.uuid}" type="product-table"><div class="editor${blockData.uuid} cke-editor-placeholder cke-editor-box product-table" editor-uuid="${blockData.uuid}" ><div class="product-table-parent-container">${defaultProductTable}</div></div></div></div></div>`;
      if (document.querySelectorAll('.dropIndicator-bottom').length === 0 &&
         document.querySelector('.template-page')?.classList.contains('addContentBox')) {
         document.querySelector('.template-page').appendChild(productTableElement);
      } 
      else {
         const parentBox = document.querySelector('.dropIndicator-bottom')?.closest('.content-box');
         parentBox?.parentNode?.insertBefore(productTableElement, parentBox.nextSibling);
      }

      this.GlobalServiceFunc.contentBoxSort();
      this.timeOutSubscription = of(null).
      pipe(
         delay(200),
         take(1)
      ).subscribe(() => {
         const editorEl = document.querySelector('.editor' + blockData.uuid);
         if (editorEl) {
            const contentBox = editorEl.closest('.content-box-inner');
            if (contentBox) {
               contentBox.classList.add('active-border');
            }
         }
      });
   }

   calculateAllSummaryBlockData(producTableUuid){
      const allBlocks = this.GlobalServiceFunc.fields_data['blocks'];
      const allBlocksArray = Array.isArray(allBlocks)
         ? allBlocks
         : Object.values(allBlocks);

      const allSummaryBlocks = allBlocksArray.filter((block: Block) => {
         if (block.type !== 'product-table-summary') return false;

         const linked = block.linked_product_tables ?? []; // safe default

         // Convert all to numbers to avoid type mismatch issues
         const linkedIds = linked.map(id => Number(id));
         const target = Number(producTableUuid);

         return (
            linkedIds.length === 0 ||
            linkedIds.includes(0) ||
            linkedIds.includes(target)
         );
      });

      allSummaryBlocks.forEach((summaryBlock: Block) => {
         this.calculateSummaryData(summaryBlock);
      });
   }

   calculateSummaryData(blockData, returnValue?: boolean){
      const allBlocks = this.GlobalServiceFunc.fields_data['blocks'];
      const allProductTables = [
            ...Object.values(allBlocks).filter((block: Block) => block.type === 'product-table')
          ];

      let connectedProductTables = [];
      if (blockData.linked_product_tables.includes(0) || blockData.linked_product_tables.length === 0){ // all product tables
         connectedProductTables = allProductTables
      } else {
         connectedProductTables = [
                                       ...Object.values(allProductTables).filter((block: Block) => blockData.linked_product_tables.includes(block.uuid))
                                    ];
      }
      const summary = {
         qty_by_frequency: {},
         total_qty: 0,
         price_by_frequency: {},
         terms_by_frequency: {},
         total_price: 0,
         currency: ''
      };

      for (let i = 0; i < connectedProductTables.length; i++) {
         const table = connectedProductTables[i].table;
         for (const key of Object.keys(table)) {
            const item = table[key];

            const freq = item.billing_frequency;
            const qty = Number(item.qty);
            const price = Number(item.total);  // total price of that row
            let terms = Number(item.terms);  // total price of that row
            if(terms === 0){
               terms = 1;
            }
            if(!summary.currency){
               summary.currency = item.currency;
            }

            // ---- Total Qty ----
            summary.total_qty += qty;

            // ---- Qty by frequency ----
            summary.qty_by_frequency[freq] =
               (summary.qty_by_frequency[freq] || 0) + qty;

            // ---- Total Price ----
            summary.total_price += price;

            // ---- Price by frequency ----
            summary.price_by_frequency[freq] =
               (summary.price_by_frequency[freq] || 0) + price;

            summary.terms_by_frequency[freq] =
               (summary.terms_by_frequency[freq] || 0) + terms;
         }
      }
      const summaryCardElement = document.querySelector(`.summary-card[summary-uuid="${blockData.uuid}"] [column="summary-column-quantity"]`);
      if (summaryCardElement) {
         summaryCardElement.innerHTML = String(summary.total_qty);
      }
      const contractValues = this.calculateContractValues({...blockData, ...summary});
      if(returnValue){
         return {...summary, contract_values: {...contractValues}};
      } else {
         this.GlobalServiceFunc.updateBlock(blockData.uuid, {...summary, contract_values: {...contractValues}, is_updated: this.isSigningArea});
      }
   }

   calculateContractValues(blockData) {
      const prices: PricingDTO = blockData.price_by_frequency;
      const terms: PricingDTO = blockData.terms_by_frequency;
      const discountSettings = blockData.discount_settings || {};
      const taxSettings = blockData.tax_settings || {};

      let mrr = 0;
      let oneTime = prices.one_time || 0;

      const frequencyDivisor = {
         monthly: 1,
         quarterly: 3,
         semi_annually: 6,
         annually: 12,
         every_two_years: 24,
         every_three_years: 36,
         every_five_years: 60
      };

      /* 1. Calculate base MRR */
      for (const [key, value] of Object.entries(prices)) {
         if (!value || key === 'one_time') continue;
         mrr += value / (frequencyDivisor[key] || 1);
      }

      const netPerMonth = mrr;
      const netOneTime = oneTime;

      /* 2. Apply discount ONLY to values > 0 */
      const discountBlock = document.querySelector(
            `.summary-card[summary-uuid="${blockData.uuid}"] .summary-discount`
        );
      let discountValue = '';
      const isDiscountColumnVisible = blockData?.columns?.discount !== false;
      if (discountSettings.status === true && Number(discountSettings.value) > 0 && isDiscountColumnVisible) {
        if (discountBlock){
            discountBlock.classList.toggle('hidden', false);
        } 
        if (discountSettings.type === '%') {
         discountValue = `${discountSettings.value}%`;
            if (mrr > 0) {
                const mrrDiscount = mrr * (discountSettings.value / 100);
                mrr -= mrrDiscount;
            }
            if (oneTime > 0) {
                const oneTimeDiscount = oneTime * (discountSettings.value / 100);
                oneTime -= oneTimeDiscount;
            }
         } else if (discountSettings.type === 'Fixed') {
            discountValue = `-${discountSettings.value} ${blockData.currency}`;
            if (mrr > 0) {
               const mrrDiscount = Math.min(discountSettings.value, mrr);
               mrr -= mrrDiscount;
            }
            if (oneTime > 0) {
               const oneTimeDiscount = Math.min(discountSettings.value, oneTime);
               oneTime -= oneTimeDiscount;
            }
         }
         const discountValueBlock = discountBlock?.querySelector(`.summary-value`);
         if(discountValueBlock){
            this.renderer.setProperty(discountValueBlock, 'textContent', discountValue);
         }
      } else {
         if (discountBlock){
            discountBlock.classList.toggle('hidden', true);
         } 
      }

      let totalPerMonth = mrr;
      let totalOneTime = oneTime;
      const taxBlock = document.querySelector(
            `.summary-card[summary-uuid="${blockData.uuid}"] .summary-tax`
        );
      let taxValue = '';
      if (taxSettings.status === true && taxSettings.value > 0) {
        if (taxBlock){
            taxBlock.classList.toggle('hidden', false);
        } 
        if (taxSettings.type === '%') {
         taxValue = `${taxSettings.value}%`;
            if (totalPerMonth > 0) {
               const mrrTax = totalPerMonth * (taxSettings.value / 100);
               totalPerMonth += mrrTax;
            }
            if (totalOneTime > 0) {
               const oneTimeTax = totalOneTime * (taxSettings.value / 100);
               totalOneTime += oneTimeTax;
            }
         } else if (taxSettings.type === 'Fixed') {
            taxValue = `${taxSettings.value} ${blockData.currency}`;
            if (totalPerMonth > 0) {
               const mrrTax = Math.min(taxSettings.value, totalPerMonth);
               totalPerMonth += mrrTax;
            }
            if (totalOneTime > 0) {
               const oneTimeTax = Math.min(taxSettings.value, totalOneTime);
               totalOneTime += oneTimeTax;
            }
         }
         const taxValueBlock = taxBlock?.querySelector(`.summary-value`);
         if(taxValueBlock){
            this.renderer.setProperty(taxValueBlock, 'textContent', taxValue);
         }
      } else {
         if (taxBlock){
            taxBlock.classList.toggle('hidden', true);
         } 
      }

      /* 3. Derive values */
      const arr = mrr * 12;
      const acv = arr + oneTime;
      const maxTerm = Math.max(0, ...Object.values(terms));
      const tcv = mrr * maxTerm + oneTime;

      const contractValues = {
         MRR: mrr.toFixed(blockData?.no_of_decimals),
         ARR: arr.toFixed(blockData?.no_of_decimals),
         ACV: acv.toFixed(blockData?.no_of_decimals),
         TCV: tcv.toFixed(blockData?.no_of_decimals),
         netPerMonth: netPerMonth.toFixed(blockData?.no_of_decimals),
         totalPerMonth: totalPerMonth.toFixed(blockData?.no_of_decimals),
         netOneTime: netOneTime.toFixed(blockData?.no_of_decimals),
         totalOneTime: totalOneTime.toFixed(blockData?.no_of_decimals)
      };

      /* 4. Update UI */
      for (const [key, value] of Object.entries(contractValues)) {
         const col = document.querySelector(
               `.summary-card[summary-uuid="${blockData.uuid}"] [column=${key}]`
         );
         if (col) col.innerHTML = `${value} ${blockData.currency}`;
      }

      const totalCol = document.querySelector(
         `.summary-card[summary-uuid="${blockData.uuid}"] .summary-total-value`
      );
      if (totalCol) {
         const parts = [];

         if (Number(contractValues?.totalPerMonth) > 0) {
            parts.push(`${contractValues.totalPerMonth} ${blockData.currency} ${translate('Total per month text (Summary settings) - per month')}`);
         }

         if (Number(contractValues?.totalOneTime) > 0) {
            parts.push(`${contractValues.totalOneTime} ${blockData.currency}`);
         }

         totalCol.innerHTML = parts.join(' + ');
      }
      return contractValues;
   }

   /** Get dom service instance */
   private get domHelperService() {
      return this.injector.get(DomHelperService);
   }

   /** Get global service instance */
   private get GlobalServiceFunc() {
      return this.injector.get(GlobalService);
   }
   
   /** Get Popover instance */
   private get popOverFunc() {
      return this.injector.get(PopOver);
   }
}
